import { render, staticRenderFns } from "./pay-success.vue?vue&type=template&id=402304d5&scoped=true"
import script from "./pay-success.vue?vue&type=script&lang=js"
export * from "./pay-success.vue?vue&type=script&lang=js"
import style0 from "./pay-success.vue?vue&type=style&index=0&id=402304d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402304d5",
  null
  
)

export default component.exports